import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Client Pages
import HomePage from "./pages/HomePage";
import AnalysisPage from "./pages/AnalysisPage";
import ResultsPage from "./pages/ResultsPage";
import QuotePage from "./pages/QuotePage";
import TrackQuotePage from "./pages/TrackQuotePage";
import MentionsLegales from "./pages/legal/MentionsLegales";
import PolitiqueConfidentialite from "./pages/legal/PolitiqueConfidentialite";
import PolitiqueCookies from "./pages/legal/PolitiqueCookies";

// Admin Pages
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminParts from "./pages/admin/AdminParts";
import AdminAnalyses from "./pages/admin/AdminAnalyses";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminSettings from "./pages/admin/AdminSettings";
import ProDashboard from "./pages/admin/ProDashboard";
import ProStock from "./pages/admin/ProStock";
import ProReception from "./pages/admin/ProReception";
import ProVehicleDetail from "./pages/admin/ProVehicleDetail";
import AdminProUsers from "./pages/admin/AdminProUsers";
import ProLogin from "./pages/ProLogin";

// Context
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import InstallPWA from "./components/InstallPWA";
import Chatbot from "./components/Chatbot";
import CookieBanner from "./components/CookieBanner";
import AnalyticsTracker from "./components/AnalyticsTracker";
import AdminAudience from "./pages/admin/AdminAudience";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Client Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/analyse" element={<AnalysisPage />} />
          <Route path="/resultats/:analysisId" element={<ResultsPage />} />
          <Route path="/devis/:analysisId" element={<QuotePage />} />
          <Route path="/suivi/:quoteId" element={<TrackQuotePage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/politique-cookies" element={<PolitiqueCookies />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/pieces" element={<ProtectedRoute><AdminParts /></ProtectedRoute>} />
          <Route path="/admin/analyses" element={<ProtectedRoute><AdminAnalyses /></ProtectedRoute>} />
          <Route path="/admin/demandes" element={<ProtectedRoute><AdminQuotes /></ProtectedRoute>} />
          <Route path="/admin/parametres" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
          <Route path="/admin/pros" element={<ProtectedRoute><AdminProUsers /></ProtectedRoute>} />
          <Route path="/admin/audience" element={<ProtectedRoute><AdminAudience /></ProtectedRoute>} />
          
          {/* Pro Routes */}
          <Route path="/pro/login" element={<ProLogin />} />
          <Route path="/admin/pro" element={<ProtectedRoute><ProDashboard /></ProtectedRoute>} />
          <Route path="/admin/pro/stock" element={<ProtectedRoute><ProStock /></ProtectedRoute>} />
          <Route path="/admin/pro/reception" element={<ProtectedRoute><ProReception /></ProtectedRoute>} />
          <Route path="/admin/pro/vehicle/:vehicleId" element={<ProtectedRoute><ProVehicleDetail /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
        <InstallPWA />
        <Chatbot />
        <CookieBanner />
        <AnalyticsTracker />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
